import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

function OrderStatusDetails() {
    const { id } = useParams();
    const requirementDetails = {
        _id: "1",
        pincode: "560001",
        billingCycle: "Monthly",
        monthlyUnits: "1000 kWh",
        suggestion: "Solar Panel 5kW System",
        subtotal: "₹50,000",
        subsidy: "₹5,000",
        finalAmount: "₹45,000",
        createdAt: "2023-05-15T10:00:00Z",
        status: "Approved",
        farmerName: "John Doe",
        farmerPhone: "1234567890",
        farmerEmail: "john@example.com"
    };

    return (
        <div>
            <div className='bannerproduct'>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                    <h6 className="fw-semibold mb-0">Order Details</h6>
                    <ul className="d-flex align-items-center gap-2">
                        <li className="fw-medium">
                            <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                                <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                                Dashboard
                            </Link>
                        </li>
                        <li> - </li>
                        <li className="fw-medium">Order Details</li>
                    </ul>
                </div>
            </div>

            <div className='row card my-3 p-3' style={{ flexDirection: "row" }}>
                <h6 className='fw-bold fs-5 mb-3'>Order Details</h6>
                <div className='col-md-3 col-sm-6'>
                    <h6 className='fw-medium fs-6'>Order ID</h6>
                    <span>{requirementDetails.pincode}</span>
                </div>
                <div className='col-md-3 col-sm-6'>
                    <h6 className='fw-medium fs-6'>Booking Date</h6>
                    <span>{requirementDetails.billingCycle}</span>
                </div>
                <div className='col-md-3 col-sm-6'>
                    <h6 className='fw-medium fs-6'>Panel Brand</h6>
                    <span>{requirementDetails.monthlyUnits}</span>
                </div>
                <div className='col-md-3 col-sm-6'>
                    <h6 className='fw-medium fs-6'>Inverter Brand</h6>
                    <span>{requirementDetails.suggestion}</span>
                </div>

                <div className='col-md-3 col-sm-6 mt-3'>
                    <h6 className='fw-medium fs-6'>Mobile Number</h6>
                    <span>{requirementDetails.subtotal}</span>
                </div>
                <div className='col-md-3 col-sm-6 mt-3'>
                    <h6 className='fw-medium fs-6'>Email Address</h6>
                    <span>{requirementDetails.subsidy}</span>
                </div>
                <div className='col-md-3 col-sm-6 mt-3'>
                    <h6 className='fw-medium fs-6'>Address</h6>
                    <span>{requirementDetails.finalAmount}</span>
                </div>

                <div className='col-md-3 col-sm-6 mt-3'>
                    <h6 className='fw-medium fs-6'>Date</h6>
                    <span>
                        {new Date(requirementDetails.createdAt).toLocaleString()}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default OrderStatusDetails